export default __webpack_public_path__ + "media/zurb/img/legacy/axe/5-f940661e51646aec276d179256f9e57d.jpg";